interface Casino {
  id: number;
  name: string;
  rating: number;
  logo: string;
  liveGames: string;
  provider: string;
  link: string;
  badge: string;
  promoCode: string;
  bonusDescription: string;
}

interface CasinoCardProps {
  casino: Casino;
}

export default function CasinoCard({ casino }: CasinoCardProps) {
  return (
    <div className="bg-[#242429] rounded-3xl p-8 hover:shadow-2xl hover:shadow-[#d4af37]/30 transition-all duration-300 hover:scale-[1.02] relative group">
      {casino.badge && (
        <div className={`absolute top-6 right-6 ${casino.badge === 'TOP' ? 'bg-gradient-to-r from-[#c41e3a] to-[#ff4757]' : 'bg-gradient-to-r from-[#2ecc71] to-[#27ae60]'} text-white px-4 py-2 rounded-full text-sm font-bold`}>
          {casino.badge}
        </div>
      )}
      
      <div className="flex items-start gap-6 mb-6">
        <div className="w-20 h-20 rounded-full bg-[#1a1a1f] p-2 flex items-center justify-center flex-shrink-0">
          <img src={casino.logo} alt={casino.name} className="w-full h-full object-contain" />
        </div>
        <div className="flex-1">
          <h3 className="text-3xl font-bold mb-2">{casino.name}</h3>
          <div className="flex items-center gap-2">
            {[...Array(5)].map((_, i) => (
              <i key={i} className={`${i < Math.floor(casino.rating) ? 'ri-star-fill text-[#d4af37]' : 'ri-star-line text-gray-600'} text-xl`}></i>
            ))}
            <span className="text-[#d4af37] font-bold ml-2">{casino.rating}</span>
          </div>
        </div>
      </div>

      <div className="space-y-4 mb-6">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <i className="ri-gamepad-line text-[#d4af37]"></i>
            <strong className="text-gray-400 text-sm">Ключевые live-игры:</strong>
          </div>
          <p className="text-gray-300 pl-6">{casino.liveGames}</p>
        </div>

        <div>
          <div className="flex items-center gap-2 mb-2">
            <i className="ri-building-line text-[#d4af37]"></i>
            <strong className="text-gray-400 text-sm">Поставщик live-игр:</strong>
          </div>
          <div className="flex flex-wrap gap-2 pl-6">
            {casino.provider.split(', ').map((prov, idx) => (
              <span key={idx} className="bg-[#1a1a1f] px-3 py-1 rounded-full text-sm text-gray-300">
                {prov}
              </span>
            ))}
          </div>
        </div>

        <div className="bg-[#1a1a1f] rounded-xl p-4">
          <div className="flex items-center gap-2 mb-2">
            <i className="ri-gift-line text-[#d4af37]"></i>
            <strong className="text-sm">Бонус:</strong>
          </div>
          <p className="text-gray-300 text-sm">{casino.bonusDescription}</p>
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <a 
          href={casino.link}
          target="_blank"
          rel="nofollow sponsored noopener noreferrer"
          className="w-full bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black font-bold py-4 px-6 rounded-full hover:shadow-lg hover:shadow-[#d4af37]/50 transition-all duration-300 text-center flex items-center justify-center gap-2 group-hover:scale-105 whitespace-nowrap"
        >
          <i className="ri-live-line text-xl"></i>
          Играть в лайв
        </a>
        <button className="w-full bg-transparent border-2 border-[#d4af37] text-[#d4af37] font-semibold py-3 px-6 rounded-full hover:bg-[#d4af37] hover:text-black transition-all duration-300 whitespace-nowrap">
          Список столов
        </button>
      </div>
    </div>
  );
}